/**
 * An advanced search upsell used on the Header's search bar.
 * Fades in/out when show prop is changed.
 * If user is already premium, links to adv search page.
 *
 * TODO: should the premium version still link to adv search?
 *   I thought we killed that and the adv search upgrade page
 */
import React, { useRef } from 'react';
import styled from 'astroturf/react';
import { CSSTransition } from 'react-transition-group';

import routes from 'js/core_pre_webpack/routes';

const Title = styled.div`
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #999;
  margin-bottom: 26px;
`;

const Body = styled.div`
  letter-spacing: normal;
  line-height: 1.3em;
`;

const CtaButton = styled.button`
  background-color: #0954d3;
  color: #fff;
  height: 36px;
  letter-spacing: 1.15px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  font-weight: bold;
  border-radius: 3px;
  text-align: center;
  margin-top: 30px;
  padding: 0 20px;
  text-transform: uppercase;
  align-self: center;

  &:hover,
  &:focus,
  &:active {
    color: #fff;
    text-decoration: none;
  }
`;

type Props = {
  show: boolean;
  isPremium?: boolean;
};

const SearchUpsell = ({ show, isPremium = false }: Props) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <CSSTransition
      in={show}
      timeout={300}
      nodeRef={ref}
      className="search-bar-upsell-container"
    >
      <div ref={ref}>
        <Title>ACADEMIA PREMIUM FEATURE</Title>
        <Body>Search the full text of over 47 million papers on Academia.</Body>
        {isPremium ? (
          <CtaButton
            as="a"
            href={routes.advanced_search_path({
              feature: 'search',
              trigger: 'search-popover',
              from_navbar: true,
            })}
          >
            Start Advanced Search
          </CtaButton>
        ) : (
          <CtaButton
            as="a"
            href={routes.upgrade_path({
              feature: 'search',
              trigger: 'search-popover',
              from_navbar: true,
            })}
          >
            Learn More
          </CtaButton>
        )}
      </div>
    </CSSTransition>
  );
};

export default SearchUpsell;
